<div data-header-start>
  <button data-menu-toggle type="button" [attr.aria-expanded]="sidebarOpen" [attr.aria-controls]="sidebarControlsId" [attr.aria-label]="toggleSidebarAriaLabel" (click)="menuToggle.emit()">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
  </button>
  <div ui-mello-logo [mode]="logoMode" [collapsed]="brandCompact" [showBackground]="false" [interactive]="false" [attr.aria-label]="brandAlt"></div>
</div>
<div data-search-wrap>
  <label data-global-search>
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>
    <input #globalSearchInput type="search" role="combobox" autocomplete="off" aria-autocomplete="list" aria-haspopup="listbox" aria-controls="global-search-suggestions" [attr.aria-expanded]="suggestOpen()" [attr.aria-activedescendant]="activeIndex() >= 0 ? 'global-search-option-' + activeIndex() : null" [attr.placeholder]="searchPlaceholder" [attr.aria-label]="searchAriaLabel" (input)="onSearchInput(globalSearchInput.value)" (keydown)="onSearchKey($event, globalSearchInput)" (focus)="suggestOpen.set(globalSearchInput.value.trim().length > 0)" (blur)="suggestOpen.set(false)" />
  </label>
  @if (suggestOpen()) {
    <ul data-suggestions id="global-search-suggestions" role="listbox" [attr.aria-label]="searchListLabel">
      @for (item of matches(); track item.route; let i = $index) {
        <li role="option" tabindex="-1" (keydown.enter)="chooseSuggestion(item, globalSearchInput)" [id]="'global-search-option-' + i" [attr.aria-selected]="i === activeIndex()" (mousedown)="$event.preventDefault()" (click)="chooseSuggestion(item, globalSearchInput)" (mouseenter)="activeIndex.set(i)">
          <b>{{ item.label }}</b>
          <span>{{ item.description }}</span>
          <code>{{ item.route }}</code>
        </li>
      } @empty {
        <li data-empty role="presentation">{{ searchEmptyLabel }}</li>
      }
    </ul>
  }
</div>
<div data-account-wrap>
  <button data-account-trigger type="button" data-popover-trigger="account" [attr.aria-label]="userMenuAriaLabel" [attr.aria-expanded]="accountOpen()" [attr.aria-controls]="accountOpen() ? 'account-popover' : null" (click)="toggleAccount()">
    <span data-avatar aria-hidden="true">
      @if (avatarSrc) {
        <img [src]="avatarSrc" alt="" />
      } @else {
        {{ userInitials }}
      }
    </span>
    <span data-account-identity>
      <span data-account-name>{{ userName }}</span>
      @if (userRole) {
        <small>{{ userRole }}</small>
      }
    </span>
    <svg data-down viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
    <span data-notification-badge role="img" [attr.aria-label]="notificationBadgeLabel()" [hidden]="notificationUnread <= 0">{{ notificationBadgeText() }}</span>
  </button>
  @if (accountOpen()) {
    <div data-account-popover id="account-popover" data-popover="account">
      <div data-account-popover-tabs role="tablist" [attr.aria-label]="accountMenuAriaLabel">
        @for (tab of accountTabs; track tab.id) {
          <button [id]="tab.tabId" type="button" role="tab" [attr.data-account-popover-tab]="tab.id" [attr.aria-controls]="tab.panelId" [attr.aria-selected]="accountTab() === tab.id" [tabindex]="accountTab() === tab.id ? 0 : -1" (click)="selectAccountTab(tab.id)" (keydown)="onAccountTabKeydown($event, tab.id)">{{ tab.label }}</button>
        }
      </div>
      <section id="account-profile-panel" data-account-popover-panel="profile" role="tabpanel" [attr.aria-labelledby]="profileTabDomId" [hidden]="accountTab() !== profileTabId">
        <header>
          <span data-avatar data-avatar-large aria-hidden="true">
            @if (avatarSrc) {
              <img [src]="avatarSrc" alt="" />
            } @else {
              {{ userInitials }}
            }
          </span>
          <div>
            <strong>{{ userName }}</strong>
            <small>{{ userEmail }}</small>
            <small>{{ userRole }}</small>
          </div>
        </header>
        <ng-content select="[data-messenger-auth-status]"></ng-content>
        @if (roleOptions.length) {
          <div data-role-group role="group" [attr.aria-label]="viewingAsLabel">
            <span data-role-group-label>{{ viewingAsLabel }}</span>
            @for (option of roleOptions; track option.value) {
              <button type="button" [attr.data-role-option]="option.value" [attr.data-selected]="role === option.value ? '' : null" [attr.aria-pressed]="role === option.value" (click)="selectRole(option.value)">
                <span>{{ option.label }}</span>
                @if (role === option.value) {
                  <svg data-role-check viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
                }
              </button>
            }
          </div>
        }
        <hr />
        @if (themeToggle && theme) {
          <button type="button" data-action="toggle-theme" data-theme-toggle [attr.aria-label]="themeToggleLabel()" [attr.aria-pressed]="themePressed()" (click)="toggleColorScheme()">
            <span data-theme-icon aria-hidden="true">
              <svg data-theme-sun viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.3 11.3 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4m11.3-11.3 1.4-1.4"/></svg>
              <svg data-theme-moon viewBox="0 0 24 24"><path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z"/></svg>
            </span>
            <span>{{ themeToggleLabel() }}</span>
          </button>
        }
        <button type="button" data-action="profile" (click)="closeAccount()">
          <span data-theme-icon aria-hidden="true">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
          </span>
          <span>{{ profilePreferencesLabel }}</span>
        </button>
        <button type="button" data-action="help" (click)="closeAccount()">
          <span data-theme-icon aria-hidden="true">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4"/><path d="M12 17h.01"/></svg>
          </span>
          <span>{{ helpSupportLabel }}</span>
        </button>
        <hr />
        <button type="button" data-action="sign-out" (click)="onSignOut()">
          <span data-theme-icon aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </span>
          <span>{{ signOutLabel }}</span>
        </button>
      </section>
      <section id="account-notifications-panel" data-account-popover-panel="notifications" role="tabpanel" [attr.aria-labelledby]="notificationsTabDomId" [hidden]="accountTab() !== notificationsTabId">
        <ng-content select="[notifications]"></ng-content>
      </section>
    </div>
  }
</div>
